<template>
    <custom-dialog width="864px" :showClose="true" v-if="dialogShow" :visible="dialogShow" @close="dialogVisible">
        <div slot="header" class="dialog-title">
            <div>{{ type == 0 ? '选择退药项目' : '选择取消退药项目' }} <span class="ml17 colorFE8F size14"><i
                        class="el-icon-info"></i>退药后，请在收费模块退费</span></div>
            <div @click="dialogVisible"><i class="el-icon-close close-icon"></i></div>
        </div>
        <div class="refundItemContent" slot="content" v-loading="loading">
            <!-- 医保项目 -->
            <div v-if="ybProjectList.length > 0" class="mb22">
                <el-checkbox @change="changeYbChecked" v-model="ybChecked" class="fwb color1F23">医保支付项目</el-checkbox>
                <div v-for="(item, index) in ybProjectList" :key="index">
                    <div class="table" v-if="item.srcType == '1'">
                        <div class="table-header">
                            <el-checkbox disabled v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1 display-f align-i-c">
                                <div class="ml8 color1F23 fwb">中药处方</div>
                                <div v-if="item.isYlcp && item.isYlcp == '1'" class="ml8 color1F23 fwb">医联产品
                                    {{ item.orderName }}</div>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox disabled v-model="item.checked"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{ item.isYlcp == '1' ? '医联明细' : obj.productName }}</span>
                            </div>
                            <div class="number-warp disabled"
                                v-if="jgList.includes(obj.productName) && obj.srcType != '4' ">-</div>
                            <div class="number-warp disabled" v-else>{{ item.quantity }}剂*{{ obj.num }}</div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                    <div class="table" v-if="item.srcType == '15'">
                        <div class="table-header">
                            <el-checkbox disabled v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1 display-f align-i-c">
                                <div class="ml8 color1F23 fwb">中成药处方</div>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox disabled v-model="item.checked"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{ obj.productName }}</span>
                            </div>
                            <div class="number-warp disabled">{{ obj.num }}</div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                    <div class="table" v-if="item.srcType == '4'">
                        <div class="table-header">
                            <el-checkbox disabled v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1">
                                <span class="ml8 color1F23 fwb">其他收费项目</span>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox disabled v-model="obj.checked" :true-label="1"
                                    :false-label="0"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{ obj.productName }}</span>
                            </div>
                            <div class="number-warp disabled">{{ obj.quantity }}</div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
            <div v-if="projectList.length > 0">
                <el-checkbox @change="changeNotYbChecked" v-model="notYbChecked"
                    class="fwb color1F23">非医保支付项目</el-checkbox>
                <div v-for="(item, index) in projectList" :key="index">
                    <div class="table" v-if="item.srcType == '1'">
                        <div class="table-header">
                            <el-checkbox @change="projectItemChange($event, item)" v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1 display-f align-i-c">
                                <div class="ml8 color1F23 fwb">中药处方</div>
                                <div class="ml20" v-if="item.checked && doseNumberDisabled(item)">共{{
                                    item.doseNumber }}剂，退<el-input-number @change="doseNumChange($event, $event, item)"
                                        class="w100 ml8" size="mini" :min="1" :max="item.doseNumber"
                                        v-model="item.quantity"></el-input-number></div>
                                <div v-if="item.isYlcp && item.isYlcp == '1'" class="ml8 color1F23 fwb">医联产品
                                    {{ item.orderName }}</div>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <!-- ==={{ obj.checked }} -->
                                <el-checkbox :disabled="item.isYlcp && item.isYlcp == '1'"
                                    @change="itemChange($event, item)" v-model="obj.checked"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{ item.isYlcp == '1' ? '医联明细' : obj.productName }}</span>
                            </div>
                            <div class="number-warp disabled"
                                v-if="jgList.includes(obj.productName) && obj.srcType != '4'">-</div>
                            <div class="number-warp disabled" v-else>{{ item.quantity }}剂*{{ obj.num }}</div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                    <div class="table" v-if="item.srcType == '15'">
                        <div class="table-header">
                            <el-checkbox @change="projectItemChange($event, item)" v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1 display-f align-i-c">
                                <div class="ml8 color1F23 fwb">中成药处方</div>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox @change="itemChange($event, item)" v-model="obj.checked"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{ obj.productName }}</span>
                            </div>
                            <div class="number-warp disabled">{{ obj.num }}</div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                    <div class="table" v-if="item.srcType == '4'">
                        <div class="table-header">
                            <el-checkbox @change="projectItemChange($event, item)" v-model="item.checked"
                                class="fwb w32 flex-sh tac color1F23"></el-checkbox>
                            <div class="flex1">
                                <span class="ml8 color1F23 fwb">其他收费项目</span>
                            </div>
                            <div class="w86 flex-sh tac">可退数量</div>
                            <div class="w38 flex-sh tac">单位</div>
                            <div class="w124 flex-sh tac">金额</div>
                        </div>
                        <div class="table-row" v-for="obj in item.item" :key="obj.detailId">
                            <div class="checkbox-warp">
                                <el-checkbox @change="itemChange($event, item)" v-model="obj.checked"></el-checkbox>
                            </div>
                            <div class="row-content">
                                <span class="color1F23">{{ obj.productName }}</span>
                            </div>
                            <div class="number-warp">
                                <el-input-number size="big" :max="obj.maxNum" :min="0"
                                    v-model.trim="obj.quantity"></el-input-number>
                            </div>
                            <div class="unit-warp">{{ obj.unit }}</div>
                            <div class="price-warp">{{ obj.totalPrice }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tac" v-if="projectList.length == 0 && ybProjectList.length == 0">暂无可退项目</div>
        </div>
        <div class="footer" slot="footer">
            <el-checkbox @change="handelAllChecked" v-model="allChecked" class="color1F23">全选</el-checkbox>
            <div class="display-f align-i-c">
                <div class="mr16">本次退药金额预计：<span class="color1F23 fwb">￥{{ refundTotal }}</span></div>
                <custom-button type="info" size="medium" @click="dialogVisible('refundItemDialog')">取消</custom-button>
                <custom-button type="primary" size="medium" @click="comfirm">确定</custom-button>
            </div>
        </div>
    </custom-dialog>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomInput from '@/components/CustomInput'
import { formulaDTO, orderDTO } from '@/DTO/index'
import { isNull, isEmptyArray, deepClone, isNullObj } from '@/utils/validateBase'
import { Utils } from '@/utils/utils'
export default {
    // 定义引入的组件
    components: { CustomDialog, CustomInput },
    props: {
        dialogShow: {
            type: Boolean,
            default: false,
        },
        dialogObj: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            loading: false,//加载
            ybChecked: false,//医保支付项目
            notYbChecked: false,//非医保支付项目
            orderId: '',//就诊id
            refundTotal: 0,//退款总金额
            ybProjectList: [],//医保退费项目
            projectList: [],//非医保退费项目
            allChecked: false,
            type: 0,//0退药 1取消退药
            jgList: ['煎药费', '打粉', '制丸', '制膏', '加工'],
        }
    },
    //变量监听
    watch: {
        projectList: {
            deep: true,
            handler(val) {
                this.computedTotal()
                this.judeStatus()
            },
        },
        ybProjectList: {
            deep: true,
            handler() {
                this.computedTotal()
                this.judeStatus()
            },
        }

    },
    // 页面初始化
    created() {
        let { orderId, type } = this.dialogObj
        this.type = type
        this.orderId = orderId
        this.getOrderDetail()
    },
    computed: {
        computedAllChecked() {
            if (Utils.eq(this.ybProjectList.length, 0)) {
                return this.notYbChecked
            } else if (Utils.eq(this.projectList.length, 0)) {
                return this.ybChecked
            } else {
                return this.ybChecked && this.notYbChecked ? true : false
            }
        },
        doseNumberDisabled() {
            return function (item) {
                let listObj = this.originalData.find(obj => { return item.ctOrderId == obj.ctOrderId }) //筛选出当前处方数据
                let flag = listObj.details.length == item.item.length && !(item.item.length==1  && this.jgList.includes(item.item[0].productName) && item.srcType != '4') //判断当前药品数量是否等于原始数据药品数量
                return flag
            }
        },
    },
    // 页面DOM加载完成
    mounted() { },
    //离开页面时执行
    destroyed() { },
    // 页面方法
    methods: {
        /**
         * 确定
         */
        comfirm() {
            let taskItem = []//退药商品列表
            if (this.ybChecked && !isEmptyArray(this.ybProjectList)) {
                this.ybProjectList.forEach(item => {
                    item.item.forEach(obj => {
                        taskItem.push({
                            detailId: obj.detailId,
                            returnQuantity: this.type == 0 ? this.$bigNumber(this.$bigNumber(obj.quantity, '+', isNull(obj.returnQuantity) ? 0 : obj.returnQuantity), '-', isNull(obj.refundQuantity) ? 0 : obj.refundQuantity) : this.$bigNumber(obj.cancelNum, '-', obj.quantity)
                            // returnQuantity: this.type == 0 ? this.$bigNumber(obj.quantity, '+', isNull(obj.returnQuantity) ? 0 : obj.returnQuantity) : this.$bigNumber(obj.cancelNum, '-', obj.quantity)
                        })
                    })

                })
            }
            if (!isEmptyArray(this.projectList)) {
                this.projectList.forEach(item => {
                    if (!isNull(item.item)) {
                        item.item.forEach(obj => {
                            if (obj.checked) {
                                taskItem.push({
                                    detailId: obj.detailId,
                                    returnQuantity: this.type == 0 ? this.$bigNumber(this.$bigNumber(obj.quantity, '+', isNull(obj.returnQuantity) ? 0 : obj.returnQuantity), '-', isNull(obj.refundQuantity) ? 0 : obj.refundQuantity) : this.$bigNumber(obj.cancelNum, '-', obj.quantity)
                                })
                            }

                        })
                    }
                })
            }
            if (isEmptyArray(taskItem)) return this.$message.error('请选择退费项目')
            let obj = {
                orderId: this.orderId,
                returnDetailList: taskItem
            }
            this.editDrugReturn(obj)
        },

        /**
         * 编辑退药
         */
        async editDrugReturn(obj) {
            let { code, data } = await formulaDTO.editDrugReturn(obj)
            if (code == 200) {
                this.type == 0 ? this.$message.success('退药成功') : this.$message.success('取消退药成功')
                this.$emit('editDrugSuccess')
            }
        },

        /**
         * 选择某个处方
         */
        projectItemChange(val, item) {
            item.checked = val
            item.item && item.item.forEach(obj => {
                obj.checked = val
            })
            if (!isEmptyArray(this.ybProjectList)) {
                let obj = this.ybProjectList.find(obj => { return item.isYlcp == '1' && item.orderNumber == obj.orderNumber })
                if (!isNullObj(obj)) { this.changeYbChecked(val) }
            }
        },
        /**
         * 选择某个商品
         */
        itemChange(val, item) {
            item.quantity = item.doseNumber
            item.item && item.item.forEach(obj => {
                obj.quantity = this.type == 0 ? Number(this.$bigNumber(obj.allNum, '-', isNull(obj.returnQuantity) ? 0 : obj.returnQuantity)) : Number(obj.cancelNum)
            })
        },
        /**
         * 全选
         */
        handelAllChecked(val) {
            this.ybChecked = val
            this.notYbChecked = val
            this.changeNotYbChecked(val)
            this.changeYbChecked(val)
        },

        /**
         * 选择医保项目
         */
        changeYbChecked(val) {
            this.ybProjectList.forEach(item => {
                this.projectList.forEach(kid => {
                    if (item.orderNumber == kid.orderNumber && kid.isYlcp && kid.isYlcp == '1') {
                        this.$set(kid,'checked',val)
                        kid.item && kid.item.forEach(kkid => {kkid.checked = val})
                    }
                })
                item.checked = val
                item.item && item.item.forEach(obj => {
                    obj.checked = val
                })
            })
        },

        /**
         * 全选非医保项目
         */
        changeNotYbChecked(val) {
            this.projectList.forEach(item => {
                item.checked = val
                item.item && item.item.forEach(obj => {
                    obj.checked = val
                })
                if (item.isYlcp == '1') {
                    if (!isEmptyArray(this.ybProjectList)) {
                        let obj = this.ybProjectList.find(obj => { return item.orderNumber == obj.orderNumber })
                        if (!isNullObj(obj)) {
                            this.changeYbChecked(val)
                            return
                        }
                    }
                }
            })
        },
        /**
         * 付数改变
         */
        doseNumChange(currentValue, oldValue, item) {
            item.item && item.item.forEach(obj => {
                obj.quantity = this.jgList.includes(obj.productName) && item.srcType!='4' ? 1 : this.$bigNumber(obj.num, '*', currentValue)
            })
        },

        /**
         * 处理退药数据
         * detailList明细列表
         * retrunList 已经退药数量
         */
        handleRefundData(detailList) {
            // 筛选出非理疗处方
            let newList = detailList.filter(item => { return item.srcType != '2' })
            //筛选医保项目
            let ybProjectList = []
            let projectList = []
            if (!isEmptyArray(newList)) {
                newList.forEach(item => {
                    item.checked = false;
                    let newDetailsNot = [] //未退明细
                    let newDetails = [] //已退明细
                    let ybItems = []
                    let items = []
                    item.details && item.details.forEach(obj => {
                        obj.cancelNum = isNull(obj.cancelNum) ? 0 : obj.cancelNum
                        obj.quantity = this.type == 0 ? Number(this.$bigNumber(obj.allNum, '-', isNull(obj.returnQuantity) ? 0 : obj.returnQuantity)) : Number(obj.cancelNum)
                        obj.maxNum = this.type == 0 ? Number(this.$bigNumber(obj.allNum, '-', isNull(obj.returnQuantity) ? 0 : obj.returnQuantity)) : Number(obj.cancelNum) //最高可退
                        obj.checked = false
                        if (Utils.gt(obj.quantity, 0) && obj.productName != '挂号费') {
                            newDetailsNot.push(obj)
                        }
                        if (Utils.gt(obj.cancelNum, 0) && obj.productName != '挂号费') {
                            newDetails.push(obj)
                        }
                    })
                    if (this.type == 0) {
                        // 处理退药数据
                        item.details = newDetailsNot
                        if(item.details.length==1 && this.jgList.includes(item.details[0].productName) && item.srcType != '4'){
                            //处方内只有加工费存在
                            item.quantity=item.doseNumber
                        }else{
                            item.details && item.details.forEach(obj => {
                            let { allNum, returnQuantity, num } = this.jgList.includes(item.details[0].productName) && item.srcType != '4' ? item.details[1] : item.details[0]
                            item.doseNumber = Number(this.$bigNumber(this.$bigNumber(allNum, '-', isNull(returnQuantity) ? 0 : returnQuantity), '/', num))
                            item.quantity = Number(item.doseNumber)
                            })
                        }
                        // item.details && item.details.forEach(obj => {
                        //     let { allNum, returnQuantity, num } = this.jgList.includes(item.details[0].productName) && item.srcType != '4' ? item.details[1] : item.details[0]
                        //     item.doseNumber = Number(this.$bigNumber(this.$bigNumber(allNum, '-', isNull(returnQuantity) ? 0 : returnQuantity), '/', num))
                        //     item.quantity = Number(item.doseNumber)
                        // })
                    } else {
                        // 处理取消退药数据
                        item.details = newDetails
                        item.details && item.details.forEach(obj => {
                            if (Utils.eq(item.details.length, 1) && this.jgList.includes(item.details[0].productName) && item.srcType != '4') {
                                item.quantity = item.doseNumber
                            } else {
                                let { cancelNum, num } = this.jgList.includes(item.details[0].productName) && item.srcType != '4' ? item.details[1] : item.details[0]
                                item.doseNumber = Number(this.$bigNumber(cancelNum, '/', num))
                                item.quantity = Number(item.doseNumber)
                            }
                        })
                    }
                    ybItems = item.details.filter(obj => { return obj.isMedical == '1' })
                    items = item.details.filter(obj => { return obj.isMedical == '0' })
                    if (!isEmptyArray(ybItems)) {
                        ybProjectList.push({
                            ...item,
                            item: ybItems,
                        })
                    }
                    if (!isEmptyArray(items)) {
                        projectList.push({
                            ...item,
                            item: items,
                        })
                    }
                })
            }
            this.ybProjectList = ybProjectList
            this.projectList = projectList
            this.handelAllChecked(true)
        },

        /**
         * 处理取消退药数据
         * detailList 明细
         */
        handleCancelData(detailList) {
            console.log(detailList, 2222222);
        },

        /**
        * 查询订单明细
        */
        async getOrderDetail() {
            this.loading = true
            let { code, data } = await orderDTO.getOrderDetail({ orderId: this.orderId, orderType: 4 })
            if (code == 200) {
                this.loading = false;
                this.originalData = isNull(data) ? [] : deepClone(data)
                this.getFormulaDrugReturn(data)
            }
        },

        /**
         * 获取退药记录
         * detailList 明细列表
         */
        async getFormulaDrugReturn(detailList) {
            let { code, data } = await formulaDTO.getFormulaDrugReturn({ orderId: this.orderId })
            if (code == 200) {
                detailList.forEach(item => {
                    item.details && item.details.forEach(obj => {
                        data.forEach(kid => {
                            if (obj.detailId == kid.detailId) {
                                obj.refundQuantity = kid.refundQuantity //已退款数量
                                obj.returnQuantity = kid.returnQuantity //已退药数量
                                obj.cancelNum = this.$bigNumber(obj.returnQuantity, '-', obj.refundQuantity) //可取消退药数量=已退药数量-已退款数量
                            }
                        })
                    })
                })
                this.handleRefundData(detailList)
            }
        },

        /**
        * 关闭
        */
        dialogVisible() {
            this.$emit("closeDialog");
        },

        /**
         * 计算退款总价
         */
        computedTotal() {
            let total = 0
            this.ybProjectList.forEach(item => {
                item.item && item.item.forEach(obj => {
                    if (this.jgList.includes(obj.productName) && item.srcType != '4') {
                        obj.totalPrice =  obj.realPrice
                        // obj.totalPrice = item.isYlcp == '1' ? this.$bigNumber(obj.realPrice, '*', item.doseNumber) : obj.realPrice
                    } else {
                        obj.totalPrice = this.$bigNumber(obj.quantity, '*', obj.realPrice, 2) //小计=付数*原本购买数量*价格
                    }
                    if (obj.checked) total = this.$bigNumber(obj.totalPrice, '+', total)
                })
            })
            this.projectList.forEach(item => {
                item.item && item.item.forEach(obj => {
                    if (this.jgList.includes(obj.productName) && item.srcType != '4') {
                        // obj.totalPrice = item.isYlcp == '1' ? this.$bigNumber(obj.realPrice, '*', item.doseNumber) : obj.realPrice
                        obj.totalPrice =  obj.realPrice
                    } else {
                        obj.totalPrice = this.$bigNumber(obj.quantity, '*', obj.realPrice, 2) //小计=付数*原本购买数量*价格
                    }
                    if (obj.checked) total = this.$bigNumber(obj.totalPrice, '+', total)
                })
            })
            this.refundTotal = total
        },
        /**
         * 判断是否全选
         */
        judeStatus() {
            this.ybProjectList.forEach(item => {
                item.checked = item.item && item.item.every(obj => { return obj.checked })
            })
            this.projectList.forEach(item => {
                item.checked = item.item && item.item.every(obj => { return obj.checked })
            })
            this.ybChecked = this.ybProjectList.every(item => { return item.checked })
            this.notYbChecked = this.projectList.every(item => { return item.checked })
            this.allChecked = this.ybChecked && this.notYbChecked
        },
    },
}
</script>
<style lang="less" scoped>
.dialog-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 24px;
    border-bottom: 1px solid #EBEAEE;
    color: #1F2329;
    font-size: 16px;
    font-weight: 500;

    .close-icon {
        width: 16px;
        height: 16px;
        ;
    }
}

.refundItemContent {
    max-height: 650px;
    overflow: auto;

    .disabled {
        background: #f8f9f9;
        cursor: not-allowed;
    }

    .table {
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #D3D3D5;
        margin-top: 14px;
    }

    .table-header {
        width: 100%;
        display: flex;
        height: 40px;
        align-items: center;
        background: #F0F1F3;
        border-bottom: 1px solid #D3D3D5;
    }

    .table-row {
        display: flex;
        height: 39px;
        border-bottom: 1px dashed #D3D3D5;

        &:last-child {
            border-bottom: none;
        }

        .checkbox-warp {
            width: 32px;
            line-height: 40px;
            text-align: center;
            flex-shrink: 0;
            border-right: 1px dashed #D3D3D5;
        }

        .row-content {
            flex: 1;
            padding-left: 8px;
            line-height: 40px;
            border-right: 1px dashed #D3D3D5;
        }

        .number-warp {
            width: 86px;
            height: 39px;
            line-height: 39px;
            border-right: 1px dashed #D3D3D5;
            display: flex;
            justify-content: center;

            /deep/.el-input-number__decrease {
                display: none;
            }

            /deep/.el-input-number__increase {
                display: none;
            }

            /deep/.el-input__inner {
                width: 86px;
                font-weight: normal;
                box-sizing: border-box;
                text-align: center;
                height: 39px;
                border-radius: 0;
                border: none;
                color: #1F2329 !important;
                padding: 0;
            }
        }

        .unit-warp {
            width: 38px;
            height: 39px;
            line-height: 39px;
            border-right: 1px dashed #D3D3D5;
            text-align: center;
            background: #f8f9f9;
            cursor: not-allowed;
        }

        .price-warp {
            width: 124px;
            height: 39px;
            line-height: 39px;
            // border-right: 1px dashed #D3D3D5;
            text-align: center;
            background: #f8f9f9;
            cursor: not-allowed;
        }
    }

}

.footer {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    border-top: 1px solid #EBEAEE;
}
</style>